exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-ourportfolio-images-content[data-v-790e2cfb]{text-align:center}.about-ourportfolio-images-content .about-ourportfolio-images[data-v-790e2cfb]{display:inline-block;max-width:500px;margin-top:40px;margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-790e2cfb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/molecules/PmOurPortfolio.vue
// module id = 184
// module chunks = 0